import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Chip, EnabledTransactionTypesPill, InstantChip, NoInstantChip, Text } from '@reveni-io/reveni-ui'

import { getExtraCredit } from '../helpers'
import * as Styles from './styles'

const RefundMethodChips = ({ refundMethod, currency }) => {
  const theme = useTheme()
  const { i18n } = useTranslation()

  const status = refundMethod.is_enabled ? 'success' : 'cancelled'
  const extraCredit = getExtraCredit(refundMethod, currency, i18n.language)

  return (
    <Styles.TagsContainer>
      {refundMethod.instant_allowed ? <InstantChip status={status} /> : <NoInstantChip status={status} />}
      <EnabledTransactionTypesPill
        refund={refundMethod.enabled_for_refunds}
        exchange={refundMethod.enabled_for_exchanges}
        isDisabled={!refundMethod.is_enabled}
      />
      {extraCredit && (
        <Chip
          disabled={!refundMethod.is_enabled}
          label={
            <Text
              type="bodyMonospaced"
              color={refundMethod.is_enabled ? theme.colors.accent.hover : theme.colors.text.subtle}
            >
              {extraCredit}
            </Text>
          }
          backgroundColor={theme.colors.warning.surface}
        />
      )}
    </Styles.TagsContainer>
  )
}

export default RefundMethodChips
